import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

export default Route.extend({
  theme: Theme.PAGE,

  model() {
    let model = this.modelFor('app.publicid');
    this.updateContext(model);

    if (model.page) {
      model.activeTab = 0;
      model.albumName = null;
      return model;
    } else {
      return { contact: model.contact, theme: Theme.PROFILE };
    }
  },

  updateContext(model) {
    this.theme = model.page ? Theme.PAGE : Theme.PROFILE;
  },
});
